import Cookies from 'universal-cookie';

export const cookies = new Cookies();

const TOKEN = '@@dive';
export const setToken = (token: string) => cookies.set(TOKEN, token);
export const getToken = () => cookies.get(TOKEN);
export const deleteToken = () => cookies.remove(TOKEN);

const ACCOUNT_TYPE = 'ACCOUNT_TYPE';
export const setAccountType = (accountType: string) =>
  cookies.set(ACCOUNT_TYPE, accountType);
export const getAccountType = () => cookies.get(ACCOUNT_TYPE);
export const deleteAccountType = () => cookies.get(ACCOUNT_TYPE);

export const deleteAllCookies = () => {
  deleteToken();
  deleteAccountType();
};

export const DIVE_ACCOUNT = 'DIVE_ACCOUNT';
export const setDiveAccount = (account) =>
  cookies.set(
    DIVE_ACCOUNT,
    JSON.stringify(account),
    { expires: new Date(Date.now() + 2 * 3600 * 1000) } // In 2 hours
  );

const CLOUD_FRONT_KEY_PAIR_ID = 'CloudFront-Key-Pair-Id';
const CLOUD_FRONT_POLICY = 'CloudFront-Policy';
const CLOUD_FRONT_SIGNATURE = 'CloudFront-Signature';

const cloudFrontCookiesOption = {
  domain: '.getmindset.com',
  path: '/',
  expires: new Date(Date.now() + 8 * 3600 * 1000) // In 8 hours
}
export const setCloudFrontKeyPairId = (keyPairId: string) =>
  cookies.set(CLOUD_FRONT_KEY_PAIR_ID, keyPairId, cloudFrontCookiesOption);
export const getCloudFrontKeyPairId = () => cookies.get(CLOUD_FRONT_KEY_PAIR_ID);
export const setCloudFrontKeyPolicy = (policy: string) =>
  cookies.set(CLOUD_FRONT_POLICY, policy, cloudFrontCookiesOption);
export const setCloudFrontSignature = (signature: string) =>
  cookies.set(CLOUD_FRONT_SIGNATURE, signature, cloudFrontCookiesOption);
